let Custom;

// Handle header
document.addEventListener('scroll', function() {
    let header = document.querySelector('header');
    let position = document.documentElement.scrollTop || document.body.scrollTop;

    if (position > 100) {
        header.classList.add('header--small');
    } else {
        header.classList.remove('header--small');
    }

});

export default Custom;